import Vue from 'vue'
import App from './App.vue'
import globalData from './lib/globalData'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import router from './router'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './scss/app.scss'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import Tooltip from 'vue-directive-tooltip';
Vue.use(Tooltip);

import io from 'socket.io-client';
const socket = io(process.env.VUE_APP_SOCKET_PRO, {transports: ['polling', 'websocket'], secure: true});

socket.on('connect', () => {
  if (globalData.browser_id) {
    socket.emit('online', {browserId: globalData.browser_id});
  }
});

Vue.config.productionTip = false

Vue.mixin({
  data: () => ({
    globalData,
    socket
  }),

  methods: {
    online: function () {
      socket.emit('online', {browserId: globalData.browser_id});
    }
  }
})

new Vue({
  router,
  render: h => h(App),
  directives: {
    tooltip: Tooltip,
  },
}).$mount('#app')
